
// This is an auto generated file - do not edit!
// Swagger path: /api/Aml/app/{appId}/refresh

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from '../base-api.service';


@Injectable({ providedIn: 'root' })
export class AmlAppAppidRefreshApiService extends BaseApiService {
    
    patch(appId: string, body: any, options = {}): Observable<any> {
        return this._patch<any, any>(
            `/Aml/app/${appId}/refresh`,
            body,
            options
        );
    }
}
